import { RedirectToSignIn, SignedIn, SignedOut } from "@clerk/clerk-react";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { AppSidebar } from "~/components/app-shell/app-sidebar";
import { NavCrumbs } from "~/components/app-shell/nav-crumbs";
import { TransitionLoader } from "~/components/app-shell/transition-loader";
import { ErrorScreen } from "~/components/error-screen";
import { SidebarInset } from "~/components/ui/sidebar";

export const Route = createFileRoute("/(app)")({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    if (context.auth.isLoaded && context.auth.isSignedIn) {
      const { trpc, queryClient } = context;
      const onboardingStatusQuery =
        trpc.onboarding.getOnboardingState.queryOptions();

      const hasNotCompletedOnboarding = !(
        await queryClient.ensureQueryData(onboardingStatusQuery)
      ).isCompleted;

      if (hasNotCompletedOnboarding) {
        throw redirect({ to: "/onboarding" });
      }
    }
  },
  errorComponent: ({ error }) => (
    <>
      <SignedOut>
        <ErrorScreen error={error} />
      </SignedOut>
      <SignedIn>
        <AppSidebar />
        <SidebarInset className="h-[calc(100vh-16px)] overflow-hidden">
          <ErrorScreen error={error} />
        </SidebarInset>
      </SignedIn>
    </>
  ),
});

function RouteComponent() {
  return (
    <>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
      <SignedIn>
        <TransitionLoader />

        <AppSidebar />
        <SidebarInset
          className="h-[calc(100vh-16px)] overflow-hidden grid grid-cols-[auto_1fr] grid-rows-[auto_1fr]"
          style={{ gridTemplateAreas: `"nav header" "main main"` }}
        >
          <NavCrumbs />
          <Outlet />
        </SidebarInset>
      </SignedIn>
    </>
  );
}
